interface IParams {
  updatedCount: number;
  desiredCount: number;
  totalCount: number;
}

export const UpdateProgress = ({
  updatedCount,
  desiredCount,
  totalCount,
}: IParams) => {
  const safeTotalCount =
    Number.isFinite(totalCount) && totalCount > 0 ? totalCount : 0;

  if (safeTotalCount === 0) {
    return (
      <div className="col-span-12 text-sm font-light" role="status">
        No devices in this operation.
      </div>
    );
  }

  const desiredPercentage = getPercentage(
    desiredCount,
    safeTotalCount,
  );
  const updatedPercentage = getPercentage(
    updatedCount,
    safeTotalCount,
  );

  return (
    <>
      <div className="col-span-12">
        <div className="h-6 relative w-full overflow-hidden align-middle text-right">
          <div className="w-full h-full bg-blue-200 absolute pr-1 pt-0.5 ">
            {totalCount}
          </div>
          <div
            className="mt-0.5 h-5 bg-blue-600 absolute pr-1 text-white"
            style={{
              width: `${desiredPercentage}%`,
            }}
          >
            {desiredCount}
          </div>
          <div
            className="mt-0.5 h-5 bg-blue-900 absolute pr-1 text-white"
            style={{
              width: `${updatedPercentage}%`,
            }}
          >
            {updatedCount}
          </div>
        </div>
      </div>

      <div className="col-span-4">
        <BulletPoint text="Updated" className="bg-blue-900" />
      </div>
      <div className="col-span-4">
        <BulletPoint text="Desired" className="bg-blue-600" />
      </div>
      <div className="col-span-4">
        <BulletPoint text="Total" className="bg-blue-200" />
      </div>
    </>
  );
};

function getPercentage(value: number, total: number) {
  if (!Number.isFinite(value)) return 0;

  return Math.min(100, Math.max(0, (100 * value) / total));
}

const BulletPoint = ({
  text,
  className,
}: {
  text: string;
  className: string;
}) => (
  <>
    <div
      className={`rounded-full h-3 w-3 items-center justify-center inline-block mr-2 ${className}`}
    ></div>
    {text}
  </>
);
